import React from 'react';
import classnames from 'classnames';
import { compose } from 'redux';
import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import Slider from '../../../Slider';
import FolderCard from '../../../FolderCard';
import GallectionControlButtons from '../GallectionControlButtons';
import withCurrentGallectionSubfolders from '../../_hocs/withCurrentGallectionSubfolders';
import { moveGallectionToPosition, } from '../../actions';
import withCurrentSubfolder from '../../_hocs/withCurrentSubfolder';
import { getMode } from '../../selectors';
import { MediaPopupMode } from '../../types';
import s from './SubfolderSlider.scss';
var enhance = compose(withCurrentGallectionSubfolders, withCurrentSubfolder, connectMediaStore(function (state) { return ({ mode: getMode(state) }); }, {
    moveGallectionToPosition: moveGallectionToPosition,
}));
export var SubfolderSlider = function (_a) {
    var mode = _a.mode, subfolders = _a.subfolders, currentSubfolderId = _a.currentSubfolderId, setCurrentSubfolderId = _a.setCurrentSubfolderId, moveGallectionToPositionAction = _a.moveGallectionToPosition;
    if (!subfolders.length) {
        return null;
    }
    var existingFolderNames = subfolders.map(function (gallection) { return gallection.name; });
    var withControls = mode === MediaPopupMode.MANAGER;
    return (React.createElement("div", { className: s['slider-wrapper'] },
        React.createElement(Slider, { className: s['slider'] }, subfolders.map(function (folder, index) {
            var isSelected = folder.folderId === currentSubfolderId;
            return (React.createElement(FolderCard, { isSelected: isSelected, onClick: function () { return setCurrentSubfolderId(folder.folderId); }, withLink: false, className: classnames(s['folder-card'], withControls && s['with-controls']), key: folder.folderId, folder: folder, statsClassName: s['folder-stats'], extras: withControls && (React.createElement(GallectionControlButtons, { className: classnames(s['gallection-control-buttons'], isSelected && s['gallection-control-buttons-on-selected']), moreMenuClassName: s['gallection-control-menu'], gallection: folder, existingGallectionNames: existingFolderNames, canMoveBack: index !== 0, canMoveForward: index !== subfolders.length - 1, onMoveBack: function () {
                        return moveGallectionToPositionAction({
                            folderId: folder.folderId,
                            position: index - 1,
                        });
                    }, onMoveForward: function () {
                        return moveGallectionToPositionAction({
                            folderId: folder.folderId,
                            position: index + 1,
                        });
                    } })) }));
        }))));
};
SubfolderSlider.displayName = 'SubfolderSlider';
export default enhance(SubfolderSlider);
//# sourceMappingURL=SubfolderSlider.connected.js.map